import React from 'react';
import PropTypes from 'prop-types';

import { AppLink, routeNaming } from '../../routes';
import { ProductImage } from '../product-image';
import styles from './SimpleProductCard.css';

const IPropTypes = {
  className: PropTypes.string,
  product: PropTypes.shape({
    ableToSell: PropTypes.bool.isRequired,
    brand: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    financing: PropTypes.shape({
      priceString: PropTypes.string.isRequired,
    }).isRequired,
    id: PropTypes.string.isRequired,
    coverImage: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  className: '',
};

const SimpleProductCard = props => (
  <article className={[styles.container, props.className].join(' ')}>
    <AppLink
      className={styles.productLink}
      pathParams={{ id: props.product.id }}
      routeName={routeNaming.PRODUCT_DETAIL}
    >
      <div className={styles.imageContainer}>
        <ProductImage
          className={styles.image}
          size="md"
          src={props.product.coverImage}
        />
      </div>
      <div className={styles.textContainer}>
        <p className={styles.brand}>
          {props.product.brand}
        </p>
        <h3 className={styles.name}>
          {props.product.name}
        </h3>
        {
          props.product.financing && props.product.financing.priceString &&
          <p className={styles.price}>
            ${props.product.financing.priceString}
          </p>
        }
        {
          (!props.product.financing || !props.product.financing.priceString) &&
          <p className={styles.undefinedPrice}>
            Precio sin determinar
          </p>
        }
      </div>
    </AppLink>
  </article>
);

SimpleProductCard.propTypes = IPropTypes;
SimpleProductCard.defaultProps = defaultProps;

export { SimpleProductCard };



// WEBPACK FOOTER //
// ./src/common/simple-product-card/SimpleProductCard.jsx